import { useContext } from "react";
import { AuthContext } from "../AuthProvider.tsx";

export const useAuthToken = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthToken must be used within an AuthProvider");
  }
  return context;
};
